import { Configure, Index, useHits, useInstantSearch, useSearchBox } from "react-instantsearch";
import NoResults from "../../search-results/components/NoResults";
import { searchIndexes } from "../../search-shared/client";
import { VirtualSearchBox } from "../../search-shared/VirtualSearchBox";
import { Page, PageHit } from "../../search-results/page";
import { PageCardSkeleton } from "./PageCardSkeleton";
import { PageCard } from "./PageCard";
import { useIndexName } from "../../search-results/components/IndexNameProvider";

function PageHitsContent() {
    const { status } = useInstantSearch();
    const { items } = useHits<Page>();

    const onSelect = (hit: PageHit) => {
      const baseUrl = window.location.origin;
      window.location.href = `${baseUrl}/pages/${hit.handle}`;
    }

    return (
      <>
          <div className="tw-space-y-3">
              {((status === "loading" || status === "stalled")) &&
                  Array(6).fill(null).map((_, index) => <PageCardSkeleton key={index} />)
              }
              {(status === "idle") && items.length > 0 ?
                  items.map((item) => <PageCard key={item.objectID} onSelect={onSelect} pageHit={item} layout="horizontal" />)
                  : <NoResults />}
          </div>
      </>
  )
}

export default function PageHits() {
  const { pages_autocomplete_hits_per_page = 6 } = window.algoliaShopify.config;
  const { query } = useSearchBox();
  const { indexName: currentIndex } = useIndexName();

  return (
    <Index indexName={searchIndexes.PAGES}>
      <VirtualSearchBox />
      <Configure
          hitsPerPage={pages_autocomplete_hits_per_page}
          query={query}
      />
      {currentIndex === searchIndexes.PAGES &&
        <PageHitsContent />
      }
    </Index>
  )
}